/**
 * FooterDisclaimer - Legal disclaimer text at bottom of page
 */

import '../../dashboard/dashboard-reset.css';

export function FooterDisclaimer() {
  return (
    <div className="dashboard-reset text-center">
      <p className="text-xs leading-relaxed text-slate-400">
        Catch is not a diagnostic tool and does not provide medical advice.
        Our risk assessments are based on peer-reviewed research and are intended
        to support, not replace, discussions with your healthcare provider.
        Always consult a qualified medical professional for health decisions.
      </p>
    </div>
  );
}

export default FooterDisclaimer;
